import {useIsDesktop} from '@eCommerce/frontend-legacy-shared-library-native';
import {Flex, View} from 'native-base';
import React from 'react';

import SecurityMask from 'components/SecurityMask';

import {GatedModulePropTypes} from '..';
import GatedProfilePanel from '../GatedProfilePanel';
import GatedCityStateZip from '../SubComponents/GatedCityStateZip';
import GatedCountry from '../SubComponents/GatedCountry';

const GatedPersonalInfoModule: React.FC<GatedModulePropTypes> = ({
  mfaOptinStatus,
  onPrimaryPress,
  isLoading,
}) => {
  const isDesktop = useIsDesktop();

  return (
    <GatedProfilePanel
      isLoading={isLoading}
      panelTitle="Personal Information"
      iconName="user-circle"
      onPrimaryPress={onPrimaryPress}
      mfaOptinStatus={mfaOptinStatus}
      testID="personal-info">
      <Flex mt={2} flexDirection={isDesktop ? 'row' : 'column'}>
        <View
          minW="50%"
          paddingRight={isDesktop ? 6 : 0}
          marginBottom={isDesktop ? 0 : undefined}>
          <View mb={isDesktop ? '40px' : 4}>
            <SecurityMask title="Email Address" showAsterisk />
          </View>
          <View mb={isDesktop ? '40px' : 4} width={isDesktop ? '50%' : '80%'}>
            <SecurityMask title="Home Phone" showAsterisk />
          </View>
          <View mb={isDesktop ? '40px' : 4} width={isDesktop ? '50%' : '80%'}>
            <SecurityMask title="Cell Phone" showAsterisk />
          </View>
        </View>
        <View
          pl={isDesktop ? 6 : undefined}
          borderLeftColor={isDesktop ? 'rgba(112, 119, 132, .2)' : undefined}
          borderLeftWidth={isDesktop ? 1 : undefined}
          flexGrow={1}
          flexShrink={1}>
          <GatedCountry />
          <View mb={isDesktop ? '40px' : 4}>
            <SecurityMask title="Home Address" showAsterisk />
          </View>
          <View mb={isDesktop ? '40px' : 4}>
            <SecurityMask title="Home Address 2" showAsterisk />
          </View>
          <GatedCityStateZip />
        </View>
      </Flex>
    </GatedProfilePanel>
  );
};

export default GatedPersonalInfoModule;
